const Timelines = [
  { title: "DAILY", disabled: true },
  { title: "WEEKLY", disabled: true },
  { title: "MONTHLY", disabled: true },
  { title: "TOTAL" },
];

export default Timelines;
